/* ==========================================================================
   原生 JS 交互：导航滚动、移动菜单、搜索、轮播、渐入、商品图库、尺码弹窗。
   不自建购物车/支付/库存，商品提交仍走 Shopify 原生表单。
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var body = document.body;
  var header = document.querySelector('[data-site-header]');

  function setHeaderState() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  }

  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });

  function setPanel(panel, open) {
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    body.classList.toggle('is-locked', open);
  }

  var drawer = document.querySelector('[data-mobile-drawer]');
  document.querySelectorAll('[data-drawer-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      button.setAttribute('aria-expanded', 'true');
      setPanel(drawer, true);
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      document.querySelectorAll('[data-drawer-open]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      setPanel(drawer, false);
    });
  });

  var searchPanel = document.querySelector('[data-search-panel]');
  document.querySelectorAll('[data-search-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      button.setAttribute('aria-expanded', 'true');
      setPanel(searchPanel, true);
      var field = searchPanel && searchPanel.querySelector('input[type="search"]');
      if (field) window.setTimeout(function () { field.focus(); }, 80);
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      document.querySelectorAll('[data-search-open]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      setPanel(searchPanel, false);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    setPanel(drawer, false);
    setPanel(searchPanel, false);
    document.querySelectorAll('[data-dialog].is-open, [data-gallery-modal].is-open').forEach(function (dialog) {
      setPanel(dialog, false);
    });
  });

  /* 区块进入视口渐入 */
  var revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });
    revealItems.forEach(function (item) { revealObserver.observe(item); });
  } else {
    revealItems.forEach(function (item) { item.classList.add('is-visible'); });
  }

  /* 首页轮播：自动播放 + 按钮 + 鼠标/触摸拖拽 */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
    var counter = slider.querySelector('[data-hero-counter]');
    var prev = slider.querySelector('[data-hero-prev]');
    var next = slider.querySelector('[data-hero-next]');
    var index = 0;
    var startX = 0;
    var deltaX = 0;
    var timer;

    if (slides.length <= 1) {
      if (counter) counter.textContent = '01';
      return;
    }

    function paint() {
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      if (counter) counter.textContent = String(index + 1).padStart(2, '0');
    }

    function go(step) {
      index = (index + step + slides.length) % slides.length;
      paint();
    }

    function restart() {
      window.clearInterval(timer);
      timer = window.setInterval(function () { go(1); }, 5200);
    }

    if (prev) prev.addEventListener('click', function () { go(-1); restart(); });
    if (next) next.addEventListener('click', function () { go(1); restart(); });

    slider.addEventListener('pointerdown', function (event) {
      startX = event.clientX;
      deltaX = 0;
      slider.setPointerCapture(event.pointerId);
    });

    slider.addEventListener('pointermove', function (event) {
      if (!startX) return;
      deltaX = event.clientX - startX;
    });

    slider.addEventListener('pointerup', function () {
      if (Math.abs(deltaX) > 48) {
        go(deltaX < 0 ? 1 : -1);
        restart();
      }
      startX = 0;
      deltaX = 0;
    });

    paint();
    restart();
  });

  /* 通用弹窗：尺码表 */
  document.querySelectorAll('[data-dialog-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var dialog = document.getElementById(button.getAttribute('data-dialog-open'));
      setPanel(dialog, true);
    });
  });

  document.querySelectorAll('[data-dialog-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      setPanel(button.closest('[data-dialog]'), false);
    });
  });

  /* 商品图库放大 */
  var galleryModal = document.querySelector('[data-gallery-modal]');
  var galleryModalImage = document.querySelector('[data-gallery-modal-image]');
  document.querySelectorAll('[data-gallery-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!galleryModal || !galleryModalImage) return;
      galleryModalImage.src = button.getAttribute('data-gallery-open');
      setPanel(galleryModal, true);
    });
  });
  document.querySelectorAll('[data-gallery-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      setPanel(galleryModal, false);
      if (galleryModalImage) galleryModalImage.src = '';
    });
  });

  /* Product thumbnails */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImage = gallery.querySelector('.product-gallery__main-image');
    var mainButton = gallery.querySelector('[data-gallery-open]');
    var thumbs = gallery.querySelectorAll('[data-product-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-main-src');
        var zoomSrc = thumb.getAttribute('data-zoom-src');
        var alt = thumb.getAttribute('data-alt') || '';

        if (mainImage && src) {
          mainImage.src = src;
          mainImage.srcset = '';
          mainImage.alt = alt;
        }
        if (mainButton && zoomSrc) mainButton.setAttribute('data-gallery-open', zoomSrc);

        thumbs.forEach(function (peer) {
          var active = peer === thumb;
          peer.classList.toggle('is-active', active);
          peer.setAttribute('aria-current', active ? 'true' : 'false');
        });
      });
    });
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-quantity-input]').forEach(function (input) {
    var wrapper = input.closest('.quantity-stepper');
    if (!wrapper) return;
    var minus = wrapper.querySelector('[data-quantity-minus]');
    var plus = wrapper.querySelector('[data-quantity-plus]');

    function setQuantity(step) {
      var min = Number(input.getAttribute('min') || 1);
      var current = Number(input.value || min);
      input.value = Math.max(min, current + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (minus) minus.addEventListener('click', function () { setQuantity(-1); });
    if (plus) plus.addEventListener('click', function () { setQuantity(1); });
  });

  /* Let product media scroll naturally when the description accordion is open. */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var descriptionDetails = section.querySelector('[data-product-description-details]');
    if (!descriptionDetails) return;

    function syncDescriptionState() {
      section.classList.toggle('has-expanded-description', descriptionDetails.open);
    }

    descriptionDetails.addEventListener('toggle', syncDescriptionState);
    syncDescriptionState();
  });

  /* Product variants: selected variant id, availability, price, media, and add button */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('[data-product-form]');
    var variantSelect = section.querySelector('[data-variant-select]');
    var hiddenId = section.querySelector('[data-variant-id]');
    var addButton = section.querySelector('[data-add-to-cart]');
    var priceBox = section.querySelector('[data-product-price]');
    var priceRegular = section.querySelector('[data-product-price-regular]');
    var priceCompare = section.querySelector('[data-product-price-compare]');
    var mainImage = section.querySelector('.product-gallery__main-image');
    var mainButton = section.querySelector('.product-gallery__main[data-gallery-open]');
    var selected = [];

    if (!form || !variantSelect) return;

    var variants = Array.prototype.slice.call(variantSelect.options).map(function (option) {
      return {
        element: option,
        id: option.value,
        options: (option.getAttribute('data-options') || '').split('||'),
        available: option.getAttribute('data-available') === 'true' && !option.disabled,
        price: option.getAttribute('data-price') || '',
        comparePrice: option.getAttribute('data-compare-price') || '',
        mediaSrc: option.getAttribute('data-media-src') || '',
        mediaZoomSrc: option.getAttribute('data-media-zoom-src') || '',
        mediaAlt: option.getAttribute('data-media-alt') || ''
      };
    });

    variants.forEach(function (variant) {
      if (variant.element.selected) selected = variant.options.slice();
    });

    function matchesSelected(variant, values) {
      return variant.options.every(function (value, index) {
        return value === values[index];
      });
    }

    function findExactVariant(values) {
      return variants.find(function (variant) {
        return matchesSelected(variant, values);
      });
    }

    function findAvailableWith(position, value) {
      return variants.find(function (variant) {
        if (!variant.available || variant.options[position] !== value) return false;
        return variant.options.every(function (optionValue, index) {
          return index === position || selected[index] === optionValue;
        });
      });
    }

    function findFirstAvailableWith(position, value) {
      return variants.find(function (variant) {
        return variant.available && variant.options[position] === value;
      });
    }

    function paintSelectedButtons() {
      section.querySelectorAll('[data-option-position]').forEach(function (button) {
        var position = Number(button.getAttribute('data-option-position')) - 1;
        var isSelected = selected[position] === button.getAttribute('data-option-value');
        var available = Boolean(findAvailableWith(position, button.getAttribute('data-option-value')));

        button.classList.toggle('is-selected', isSelected);
        button.classList.toggle('is-unavailable', !available);
        button.disabled = !available;
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      section.querySelectorAll('[data-selected-option-label]').forEach(function (label) {
        var position = Number(label.getAttribute('data-selected-option-label')) - 1;
        label.textContent = selected[position] || '';
      });
    }

    function updateMedia(variant) {
      if (!variant || !variant.mediaSrc || !mainImage) return;
      mainImage.src = variant.mediaSrc;
      mainImage.srcset = '';
      mainImage.alt = variant.mediaAlt || mainImage.alt;
      if (mainButton && variant.mediaZoomSrc) mainButton.setAttribute('data-gallery-open', variant.mediaZoomSrc);

      section.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
        var active = thumb.getAttribute('data-main-src') === variant.mediaSrc;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function updateVariant() {
      var matchedVariant = findExactVariant(selected);

      if (!matchedVariant || !matchedVariant.available) {
        matchedVariant = variants.find(function (variant) { return variant.available; }) || matchedVariant;
        if (matchedVariant) selected = matchedVariant.options.slice();
      }

      if (!matchedVariant) return;

      variantSelect.value = matchedVariant.id;
      if (hiddenId) hiddenId.value = matchedVariant.id;

      if (priceRegular && matchedVariant.price) priceRegular.textContent = matchedVariant.price;
      if (priceCompare) {
        priceCompare.textContent = matchedVariant.comparePrice;
        priceCompare.classList.toggle('is-hidden', !matchedVariant.comparePrice);
      }
      if (priceBox) priceBox.classList.toggle('price--sale', Boolean(matchedVariant.comparePrice));

      if (addButton) {
        addButton.disabled = !matchedVariant.available;
        addButton.textContent = matchedVariant.available ? 'Add To Cart - ' + matchedVariant.price : 'Sold Out';
      }

      updateMedia(matchedVariant);
      paintSelectedButtons();
    }

    section.querySelectorAll('[data-option-position]').forEach(function (button) {
      var position = Number(button.getAttribute('data-option-position')) - 1;
      if (button.classList.contains('is-selected')) selected[position] = button.getAttribute('data-option-value');

      button.addEventListener('click', function () {
        if (button.disabled) return;
        var value = button.getAttribute('data-option-value');
        selected[position] = value;

        var exact = findExactVariant(selected);
        if (!exact || !exact.available) {
          var fallback = findFirstAvailableWith(position, value);
          if (fallback) selected = fallback.options.slice();
        }

        updateVariant();
      });
    });

    updateVariant();
  });
})();
